"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useMyProjects = void 0;
var GetMyProjectsBP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/get-my-projects"));
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var react_1 = __importDefault(require("react"));
function useMyProjects() {
    var client = (0, omni_continuity_1.useClient)();
    var cache = (0, omni_continuity_1.useCache)();
    var _a = react_1["default"].useState(null), projects = _a[0], setProjects = _a[1];
    var projectsQuery = client.useQuery(GetMyProjectsBP, null);
    react_1["default"].useEffect(function () {
        if (projectsQuery.data) {
            setProjects(projectsQuery.data.projects);
        }
    }, [projectsQuery.data]);
    react_1["default"].useEffect(function () {
        if (projects !== null) {
            cache.set("hiyllo/omni-tasks/my-projects", projects);
        }
    }, [projects]);
    react_1["default"].useEffect(function () {
        void cache.get("hiyllo/omni-tasks/my-projects").then(function (projects) {
            setProjects(function (current) { return (current === null ? projects !== null && projects !== void 0 ? projects : [] : current); });
        });
    }, []);
    return {
        projectsQuery: projectsQuery,
        projects: projects
    };
}
exports.useMyProjects = useMyProjects;
